/*jshint esversion: 6 */

const hamburgerMenu = document.getElementById("hamburgerMenu");
const mainContent = document.getElementById("main");
const offCanvasMenu = document.getElementById("off-canvas-menu");
let navLinksWithChildren = document.getElementsByClassName("menu-item-has-children");


function closeNav() {
    document.body.classList.remove("show-nav");
    const body = document.body;
    const scrollY = body.style.top;
    body.style.position = "";
    body.style.top = "";
    window.scrollTo(0, parseInt(scrollY || "0") * -1);
}

function openNav() {
    document.body.classList.add("show-nav");
    const scrollY = document.documentElement.style.getPropertyValue("--scroll-y");
    const body = document.body;
    body.style.position = "fixed";
    body.style.top = `-${scrollY}`;
}

function toggleNav() {
    if (document.body.classList.contains("show-nav")) {
        closeNav();
    } else {
        openNav();
    }
}


for (let i = 0; i < navLinksWithChildren.length; i++) {
    navLinksWithChildren[i].addEventListener("click", event => {

        // check link clicked is not child
        if (event.target.nextElementSibling == undefined) return;

        event.preventDefault();
        event.currentTarget.classList.toggle("is-active");

        // get ul
        let panel = event.currentTarget.children[1];

        if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
        } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
        }
    });
}


hamburgerMenu.addEventListener("click", () => {
    toggleNav();
}, false);

// mainContent.addEventListener("click", (e) => {
//     if (e.target != offCanvasMenu || e.target == hamburgerMenu) {
//         closeNav();
//     }
// }, true);

document.addEventListener("keyup", (e) => {
    if (e.keyCode === 27) {
        closeNav();
        // console.log(e);
    }
}, true);

window.addEventListener("scroll", () => {
    document.documentElement.style.setProperty("--scroll-y", `${window.scrollY}px`);
}, {
    passive: true
});